export default __webpack_public_path__ + "assets/pdf.3d052467.svg";